module.exports = __webpack_public_path__ + "img/Drag and Drop Icon.ca9adfc1.svg";